
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/resources/calculators/fct",
      function () {
        return require("private-next-pages/resources/calculators/fct.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/resources/calculators/fct"])
      });
    }
  